const GreffierMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexWrap: "wrap",
  overFlow: "hidden",
  position: "relative",
  width: "100%",
};

const GreffierSideStyle = {
  flexBasis: 380,
  flexGrow: 1,
  minHeight: "320px",
};

const GreffierMainStyle = {
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  pt: 5,
  px: 4,
};

const GreffierTitleMandataireStyle = {
  color: "textSecondary",
  fontFamily: "heading",
  fontSize: 0,
  mb: "4px",
};

const GreffierContentMandataireStyle = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: 4,
};

const GreffierTribunal = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: "5px",
};

export {
  GreffierMandataireStyle,
  GreffierTitleMandataireStyle,
  GreffierContentMandataireStyle,
  GreffierTribunal,
  GreffierSideStyle,
  GreffierMainStyle,
};
